<template>
    <fieldset>
        <h4>Find your webmail url</h4>

        <txt label="Please enter in your domain" placeholder="eg. mywork.com.au" v-model="domain"></txt>

        <div class="alert alert-danger" v-if="errors && errors.length">
            <li v-for="error in errors">
                {{ error.message }}
            </li>
        </div>

        <div class="form-group pull-right">
            <button @click.prevent="find" type="submit" class="btn btn-primary btn-lg btn-block" :class="{'btn-submitting' : submitting}">
                <i class="icon icon-spinner fa-spin" v-if="submitting"></i>
                <span>Find</span>
            </button>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default : '' }
        },
        data: function() {
            return {
                submitting: false,
                errors: [],
                domain: ''
            }
        },
        created() {
//            this.$eventHub.$on('set' + this.name + 'User', this.setUser);
        },
        methods: {
            find() {
                if (this.submitting) return;
                this.errors = [];
                this.submitting = true;
                var params = new URLSearchParams();
                params.append('domain', this.domain);
                this.axios.post('/api/webmail', params).then((response) => {
                    this.submitting = false;
                    if (typeof response.data['url'] !== 'undefined') {
                        window.location = response.data['url'];
                        return;
                    }
                    this.handleError('An unknown error occurred');
                }).catch((error) => {
                    this.handleError(error);
                });
            },
            customError(message) {
                this.errors.push({
                    error_code: 500,
                    message: message
                });
            },
            handleError(error) {
                if (typeof error.response['data'] !== 'undefined' &&
                    this.handleResponse(error.response.data)) {
                    return;
                }
                this.submitting = false;
                this.customError('An unspecified error occurred.');
            },
            handleResponse(data) {
                if (typeof data.error !== 'undefined') {
                    this.submitting = false;
                    // error with redirect: ie. token mismatch
                    if (typeof data.redirect !== 'undefined') {
                        window.location = data.redirect;
                    }
                    if (data.error === 'password') {
                        this.customError('Sorry, the password was incorrect.');
                        return true;
                    }
                    this.customError(data.error);
                    return true;
                }
                if (typeof data.errors !== 'undefined') {
                    this.submitting = false;
                    $.each(data.errors, (key, value) => {
                        this.customError(value[0]);
                    });
                    return true;
                }
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('set' + this.name + 'User', this.setUser);
        }
    }
</script>
